(function interviewerReportRoutingIIFE() {
    'use strict';

    angular
        .module('hrpro')
        .config(interviewerReportRouting);

    function interviewerReportRouting($stateProvider) {
        var DEFAULT_PERIOD = 7;

        $stateProvider
            .state('report_interviewer', {
                parent: 'app',
                url: '/reports/interviewer?start&end',
                templateUrl: '/hrpro/app/reports/interviewer/index.html',
                data: {
                    pageTitle: 'Интервьюер',
                    bodyClass: 'reports'
                },
                resolve: {
                    dateStart: function resolveDateStart($stateParams) {
                        if ($stateParams.start) {
                            return new Date($stateParams.start);
                        } else {
                            var end = new Date();
                            if ($stateParams.end) {
                                end = new Date($stateParams.end);
                            }
                            end.setDate(end.getDate() - DEFAULT_PERIOD);
                            return end;
                        }
                    },
                    dateEnd: function resolveDateEnd($stateParams, dateStart) {
                        if ($stateParams.end) {
                            return new Date($stateParams.end);
                        } else {
                            var end = new Date();
                            if (dateStart > end) {
                                end = new Date(dateStart.getTime());
                                end.setDate(end.getDate() + DEFAULT_PERIOD);
                            }
                            return end;
                        }
                    },
                    data: function resolveData(dateStart, dateEnd, ReportsApi, Notify, dateFilter) {
                        var params = {
                            start: dateFilter(dateStart, 'yyyy-MM-dd'),
                            end: dateFilter(dateEnd, 'yyyy-MM-dd'),
                        };

                        var promise = ReportsApi.getReport(ReportsApi.TYPE_INTERVIEWER, params);
                        promise.then(undefined, onError);
                        return promise;

                        function onError(response) {
                            Notify.error('Ошибка', 'Невозможно загрузить отчет');
                        }
                    },
                    currentUser: function resolveUser(MasterApi, Notify){
                        var promise = MasterApi.getMaster();
                        promise.then(undefined, onError);
                        return promise;

                        function onError(response) {
                            Notify.error('Ошибка', 'Не удалось загрузить текущего пользователя')
                        }
                    }, 
                },
                controller: 'InterviewerReportController',
                controllerAs: 'reportVM'
            });
    }
})();
